// Application Constants

// User Roles
export const USER_ROLES = {
  SUPER_ADMIN: 0,
  OWNER: 1,
  MANAGER: 2,
  EMPLOYEE: 3,
} as const;

export const USER_ROLE_LABELS: Record<number, string> = {
  [USER_ROLES.SUPER_ADMIN]: '👑 Super Admin',
  [USER_ROLES.OWNER]: '🏢 Owner',
  [USER_ROLES.MANAGER]: '👔 Manager',
  [USER_ROLES.EMPLOYEE]: '👤 Employee',
};

// Request Types
export const REQUEST_TYPES = {
  LEAVE: 0,
  SWAP_SHIFT: 1,
  EXTRA_SHIFT: 2,
  ABSENCE: 3,
} as const;

export const REQUEST_TYPE_LABELS: Record<number, string> = {
  [REQUEST_TYPES.LEAVE]: '🏖️ Ferie',
  [REQUEST_TYPES.SWAP_SHIFT]: '🔄 Scambio Turno',
  [REQUEST_TYPES.EXTRA_SHIFT]: '➕ Turno Extra',
  [REQUEST_TYPES.ABSENCE]: '🚫 Assenza',
};

// Request Statuses
export const REQUEST_STATUSES = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  CANCELLED: 3,
} as const;

export const REQUEST_STATUS_LABELS: Record<number, string> = {
  [REQUEST_STATUSES.PENDING]: 'In Attesa',
  [REQUEST_STATUSES.APPROVED]: 'Approvate',
  [REQUEST_STATUSES.REJECTED]: 'Rifiutate',
  [REQUEST_STATUSES.CANCELLED]: 'Cancellate',
};

// Shift Status Colors
export const SHIFT_STATUS_COLORS: Record<string, string> = {
  Scheduled: '#3498db',
  InProgress: '#f39c12',
  Completed: '#27ae60',
  Cancelled: '#95a5a6',
};

// Calendar
export const MONTH_NAMES = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
] as const;

export const DAY_NAMES = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'] as const;

// Pagination
export const DEFAULT_PAGE_SIZE = {
  REQUESTS: 10,
  USERS: 20,
  SHIFTS: 1000,
  SITES: 20,
} as const;

// Request Type Badge Info
export const REQUEST_TYPE_INFO: Record<
  string,
  { label: string; icon: string }
> = {
  Leave: { label: 'Ferie', icon: '🏖️' },
  SwapShift: { label: 'Scambio Turno', icon: '🔄' },
  ExtraShift: { label: 'Turno Extra', icon: '➕' },
  Absence: { label: 'Assenza', icon: '🚫' },
};

// Request Status Badge Info
export const REQUEST_STATUS_INFO: Record<
  string,
  { label: string; className: string }
> = {
  Pending: { label: 'In Attesa', className: 'pending' },
  Approved: { label: 'Approvata', className: 'approved' },
  Rejected: { label: 'Rifiutata', className: 'rejected' },
  Cancelled: { label: 'Cancellata', className: 'cancelled' },
};
